/** True when move-to-inventory is allowed for this order (not quotes-only). */
export function canMovePartsToInventory(quotesOnly?: boolean): boolean {
    return quotesOnly !== true;
}

/** Ordered (supplier) total minus units already moved to inventory. */
export function getOrderedPartRemainingQuantity(part: {
    quantity?: number | null;
    quantityInventoried?: number | null;
}): number {
    const ordered = part.quantity ?? 0;
    const inventoried = Math.max(0, part.quantityInventoried ?? 0);
    return Math.max(0, ordered - inventoried);
}
